var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 170.79 172.7" }, props),
    React.createElement(
      "title",
      null,
      "panels_single"
    ),
    React.createElement("path", { fill: "none", stroke: "#969696", strokeLinecap: "round", strokeLinejoin: "round", d: "M21.59 7.5h128.9v164.7H21.59z" }),
    React.createElement("path", { d: "M1.89 3.5h162V8h-162z" }),
    React.createElement("path", { d: "M11.29 6A5.2 5.2 0 1 1 6.09.8a5.23 5.23 0 0 1 5.2 5.2" }),
    React.createElement("circle", { cx: "6", cy: "6.07", r: "5.2", fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.607" }),
    React.createElement("path", { d: "M169.99 6a5.2 5.2 0 1 1-5.2-5.2 5.23 5.23 0 0 1 5.2 5.2" }),
    React.createElement("path", { d: "M169.99 6a5.2 5.2 0 1 1-5.2-5.2 5.23 5.23 0 0 1 5.2 5.2z", fill: "none", stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.607" })
  );
});